import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";

export const Search = forwardRef<SVGSVGElement, IconClientSVGProps>(
  ({ label, stroke = "#0F0F14", strokeOpacity = "1", ...props }, ref) => {
    return (
      <Icon label={label}>
        <svg
          ref={ref}
          {...props}
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 14.5L10.9591 11.4655M10.9591 11.4655C11.9111 10.5152 12.5001 9.20137 12.5001 7.74997C12.5001 4.85049 10.1495 2.5 7.25003 2.5C4.35052 2.5 2 4.85049 2 7.74997C2 10.6495 4.35052 12.9999 7.25003 12.9999C8.69813 12.9999 10.0093 12.4137 10.9591 11.4655Z"
            stroke={stroke}
            strokeOpacity={strokeOpacity}
            strokeLinecap="square"
          />
        </svg>
      </Icon>
    );
  },
);
